"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Error_1 = __importDefault(require("./styledComponents/Error"));

var Info_1 = __importDefault(require("./styledComponents/Info"));

var Success_1 = __importDefault(require("./styledComponents/Success"));

var Warning_1 = __importDefault(require("./styledComponents/Warning"));

var Text_1 = __importDefault(require("./styledComponents/Text"));

var Close_1 = __importDefault(require("./styledComponents/Close"));

var Toast_meta_1 = require("./Toast.meta");

var ToastType_1 = require("./models/ToastType");

var Translate_1 = __importDefault(require("../../base/Translate"));

var ButtonFlat_1 = __importDefault(require("../../base/ButtonFlat"));

var Icon_1 = __importDefault(require("../../base/Icon"));

var Toast =
/** @class */
function (_super) {
  __extends(Toast, _super);

  function Toast(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Toast_meta_1.TOAST_CATEGORY_KEY;
    _this.componentKey = Toast_meta_1.TOAST_COMPONENT_KEY;

    _this.getComponentFromType = function (type) {
      switch (type) {
        case ToastType_1.ToastType.error:
          return Error_1.default;

        case ToastType_1.ToastType.success:
          return Success_1.default;

        case ToastType_1.ToastType.warning:
          return Warning_1.default;

        case ToastType_1.ToastType.info:
        default:
          return Info_1.default;
      }
    };

    _this.handleClose = function () {
      var _a = _this.props,
          toastId = _a.toastId,
          onClose = _a.onClose;

      if (onClose) {
        onClose(toastId);
      }
    };

    return _this;
  }

  Toast.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.type,
        type = _b === void 0 ? ToastType_1.ToastType.info : _b,
        text = _a.text,
        _c = _a.canClose,
        canClose = _c === void 0 ? false : _c;
    var ToastComponent = this.getComponentFromType(type);
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(ToastComponent, null, react_1.default.createElement(Text_1.default, null, react_1.default.createElement(Translate_1.default, null, text)), canClose && react_1.default.createElement(Close_1.default, null, react_1.default.createElement(ButtonFlat_1.default, {
      onClick: this.handleClose
    }, react_1.default.createElement(Icon_1.default, {
      asset: 'base.toast.close',
      alt: 'X'
    })))));
  };

  Toast = __decorate([mobx_react_1.observer], Toast);
  return Toast;
}(shared_1.ComponentBase);

exports.Toast = Toast;
exports.default = shared_1.InjectedStyledComponent(Toast, Toast_meta_1.TOAST_CATEGORY_KEY, Toast_meta_1.TOAST_COMPONENT_KEY);